import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {  Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import sitemap1 from "../Images/Sitemap1.svg";
import sitemap2 from "../Images/sitemap2.svg";
// import tool11 from "../Images/tool11.svg";
const Sitemappage = () => {



  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b> - boost your SEO
            game&nbsp;&nbsp;
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className="mx-2">
            <h1 className="text-center">
              Generate Your Perfect Sitemap in Seconds with Our SeoBix Tool
            </h1>

            <p>
              Welcome to SeoBix, a perfect sitemap designed to be one of your
              easiest experiences. Our SeoBix Sitemap Generator tool assists
              website owners, SEO specialists, and digital marketers in
              generating error-free, SEO-friendly sitemaps in a flash.
            </p>
            <div className=" m-4 d-flex justify-content-center">
              <img
                className=""
                src={sitemap1}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <h2>Why choose SeoBix Sitemap Generator?</h2>

            <p>
              It takes an art and a science to effectively crawl and index a
              site with search engines; luckily, this sitemap generator takes
              that part and creates the sitemap in just a few simple steps.
            </p>

            <h3>Key Features of SeoBix Sitemap Generator :</h3>

            <ul>
              <li>
                <strong>Quick and Easy</strong> : Instantly generate a complete
                site map within seconds without needing technical know-how just
                by entering your website URL and letting SeoBix do the rest.
              </li>
              <li>
                <strong>SEO Optimized</strong> : The sitemaps generated are SEO
                friendly and ensure proper indexing of your pages by search
                engines like Google, Bing, and others.
              </li>
              <li>
                <strong>Supports Different Formats</strong> : SeoBix provides
                both XML format to search engines, and HTML format for users.
              </li>
              <li>
                <strong>Error-Free Generation</strong> : SeoBix Reviews Common
                Sitemap Errors and Ensures as Per Regulations your Site Map is
                Issue Free, because searching robots.
              </li>
              <li>
                <strong>Regular Updates</strong> : Dynamically Update Sitemap as
                your web evolves, assures that the current structure of your
                site is always in the loop of search engines.
              </li>
              <li>
                <strong>Custom Settings</strong> : Adapt the settings as per to
                your liking like priority, change frequency, and including URLs.
              </li>
            </ul>

            <h3>How SeoBix Sitemap Generator Works</h3>
            <div className=" m-4 d-flex justify-content-center">
              <img
                className=""
                src={sitemap2}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <ol>
              <li>
                <strong>
                  Simply input your website domain in the SEO sitemap generation
                  tool.
                </strong>
              </li>
              <li>
                <strong>Configure Your Sitemap Settings</strong> : Customize
                update frequency, priority settings, and other preferences to
                suit your SEO requirements.
              </li>
              <li>
                <strong>Generate Your Sitemap</strong> : Click on 'Generate',
                and in a matter of seconds, SeoBix will generate a sitemap for
                you.
              </li>
              <li>
                <strong>Save and Copy into Your Site Root Directory</strong> :
                After generation, download the sitemap and upload it to your
                website's root directory. If it is an XML sitemap, you can
                submit it directly to the Google Search Console and other search
                engines.
              </li>
            </ol>

            <h3>Advantages of Having a Well-Arranged Sitemap</h3>

            <ul>
              <li>
                <strong>Improved SEO</strong> : Well-organized site maps improve
                discovery in the performance of search engines and, thereby,
                indexing for all pages.
              </li>
              <li>
                <strong>Faster Indexing</strong> : Provide search engines with
                the latest list of your pages, and they would index new content
                faster.
              </li>
              <li>
                <strong>Better User Experience</strong> : For HTML sitemaps,
                through access by users easily navigating the website, user
                engagement and bounce rates will improve.
              </li>
              <li>
                <strong>Identifying Errors</strong> : Proper functioning of
                SeoBix will avoid broken links or pages from being inaccessible,
                which might otherwise affect the performance of your website's
                SEO.
              </li>
            </ul>

            <h4>Conclusion</h4>

            <p>
              Generation of a sitemap need not be a hassle, just learn how to
              use the magic of SeoBix, and you can have a perfectly optimized
              sitemap in just a few clicks. Whether you're a website owner,
              developer, or SEO professional, it'll save time and make
              everything easier.
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
          "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
    
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Sitemappage;
